import { render, staticRenderFns } from "./salaryBar.vue?vue&type=template&id=5c294822&scoped=true&"
import script from "./salaryBar.vue?vue&type=script&lang=js&"
export * from "./salaryBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c294822",
  null
  
)

export default component.exports